<template>
  <div class="statis-page">
    <div class="head_area">
      <div class="leftImg">
        <img @click="back" src="/static/image/icon-jiantou@2x.eb0b501e01e95b720b727b63a23960e3.png" class="top_back">
      </div>
      <span class="head_text">{{ $t('数据统计详情') }}</span>
      <span class="right_menu"></span>
    </div>
    <div class="table-box" style="border-top-left-radius: .27rem; border-top-right-radius: .27rem;">
      <div class="table-head tr">
        <div class="td">{{ $t('值') }}</div>
        <div class="td">{{ $t('未开期数') }}</div>
        <div class="td">{{ $t('值') }}</div>
        <div class="td">{{ $t('未开期数') }}</div>
      </div>
    </div>

    <div class="content">
      <div class="table-box" style="border-bottom-left-radius: .27rem; border-bottom-right-radius: .27rem;">
        <div class="table-content">
          <div class="tr">
            <template v-for="(item,index) in list">
              <div class="td">
                <div :class="['btn small-size', 'tag-row-'+item.css]">{{ $t(item.name) }}</div>
              </div>
              <div class="td">
                {{ item.current_unopened }}
              </div>
            </template>

          </div>
        </div>
      </div>

    </div>

  </div>
</template>


<script>
import {translateText} from "../../common/utils";

export default {
  name: 'Statis',
  data() {
    return {
      page_size: 100,
      page: 1,
      list: [],
      loading: false,
      game_video: 'jld28'
    }
  },
  mounted() {
    const query = this.$route.query;
    if(query.game_video) {
      this.game_video = query.game_video;
    }
    this.getList()
  },
  methods: {
    async showTost(type, title) {
      const message = await translateText([title]);
      this.$parent.showTost(type, message[0]);
    },
    back(){
      window.history.go(-1)
    },
    getList() {
      this.$parent.showLoading()
      this.$apiFun
        .post('/api/game/tongji', {
          type: this.game_video,
          per_page: this.page_size,
          page: this.page
        })
        .then(async (res) => {
          if (res.code !== 200) {
            this.showTost(0, res.data.message);
          }
          if (res.code === 200) {
            const list = res.data.list
            this.list = list
          }
          this.$parent.hideLoading();
          this.loading = false;
        })
        .catch(res => {
          this.$parent.hideLoading();
          this.loading = false;

        });
    },

  }
}
</script>
<style scoped lang="scss">
.statis-page {
  background: #000;
  width: 100%;
  height: 100%;
  margin: auto;
  z-index: 1;
  overflow: hidden;
  bottom: 0;
  bottom: env(safe-area-inset-bottom, 0); /* 兼容刘海/手势栏 */
  display: flex;
  flex-direction: column;
  color: #fff;
  .head_area {
    position: relative;
    z-index: 2;
    height: 1.33333rem;
    display: flex;
    align-items: center;
    padding: 0 .4rem;
    .leftImg {
      flex: 1;
      text-align: right;
      transform: rotate(180deg);
    }
    .top_back {
      width: 0.26rem;
      height: 0.37333rem;
    }
    .head_text {
      font-size: 0.438rem;
      font-weight: bold;
      font-family: PingFang SC;
      color: #fff;
      width: 80%;
      text-align: center;
    }
    .right_menu {
      font-size: 0.37333rem;
      font-family: PingFang SC;
      color: #fff;
      flex: 1;
      text-align: right;
    }
  }
  .content {
    flex: 1;
    overflow: auto;
    padding-bottom: .3rem;

  }
  .table-box {
    background: #1E2223;
    margin: 0 .4rem;
    //border-radius: .27rem;
    overflow: hidden;
    .tr {
      display: flex;
      align-items: center;
      justify-content: space-between;
      text-align: center;
      font-size: 0.32rem;
      color: #A8D3FF;
      .td {
        width: 20%;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;

        .btn {
          font-size: 0.27rem;
          color: #fff;
        }
        &:nth-child(even) {
          width: 30%;
        }
      }
    }
    .table-head {
      background: #1E2223;
      height: 0.88rem;
      display: flex;
      align-items: center;
      color: #8F9394;
    }
    .table-content {
      .tr {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        .td {
          height: 1.07rem;
          display: flex;
          align-items: center;
        }
        &:nth-child(odd) {
          background: #1E2223;
        }
        .btn {
          width: 0.78rem;
          height: 0.78rem;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 50%;
          border: .02rem solid #000;
          font-size: .25rem;
        }
        .small-size {
          font-size: .28rem;
        }
        .tag-row-1 {
          background: linear-gradient( 180deg, #00E137 0%, #00C400 47%, #00DC00 100%);
        }

        .tag-row-2 {
          background: linear-gradient( 180deg, #FF5861 0%, #EC2627 47%, #FB3E38 100%);
        }

        .tag-row-3 {
          background: linear-gradient( 180deg, #99CFFF 0%, #7D9BFD 47%, #388BF6 100%);
        }
        .tag-row-4 {
          background-color: #fff;
          color: #000;
        }
        .green-bg {
          background: linear-gradient( 180deg, #00E137 0%, #00C400 47%, #00DC00 100%);
        }
        .red-bg {
          background: linear-gradient( 180deg, #FF5861 0%, #EC2627 47%, #FB3E38 100%);
        }
        .blue-bg {
          background: linear-gradient( 180deg, #99CFFF 0%, #7D9BFD 47%, #388BF6 100%);
        }
      }
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/components/game/statis.vue